var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import BillHeader from './component/BillHeader';
import LeftTree from './component/LeftTree';
import CategoryTable from './component/CategoryTable';
import CategoryService from '../../api/CategoryService';
import GoodService from "../../api/GoodService";
import BasicArcheivesService from '../../api/BasicArcheivesService';
import { Loading } from 'element-ui';
import { UrlHelper } from '../../helper/UrlWrapper';
var PriceSetting = (function (_super) {
    __extends(PriceSetting, _super);
    function PriceSetting() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.total = 100;
        _this.data = [];
        _this.selectRows = [];
        _this.treeData = [];
        _this.formData = {};
        _this.dialogTableVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        _this.categoryData = [];
        _this.isEdit = true;
        return _this;
    }
    PriceSetting.prototype.created = function () {
        this.service = CategoryService.getInstance();
        this.goodService = GoodService.getInstance();
        this.basicArcheivesService = BasicArcheivesService.getInstance();
        this.getCategory();
        this.getTreeCategoryData();
    };
    PriceSetting.prototype.mounted = function () {
        this.search();
    };
    PriceSetting.prototype.search = function (pager) {
        var _this = this;
        pager = pager ? pager : this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = Object.assign({}, pager, {
            supplier_upper_id: this.supplier_upper_id,
            keyword: this.formData.text,
            goods_type_id: this.formData.category
        });
        this.basicArcheivesService.getGoodsPriceList(params).then(function (res) {
            if (res.data && res.data.success) {
                res.data.data.map(function (item) {
                    if (item.current) {
                        if (!!item.current.es_time) {
                            item.current.noEsTimeEdit = true;
                        }
                        if (!!item.current.ee_time) {
                            item.current.noEeTimeEdit = true;
                        }
                    }
                });
                _this.data = res.data.data;
                _this.total = res.data.total;
            }
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message || err.msg);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    PriceSetting.prototype.save = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择货品！');
            return;
        }
        var paramsData = this.selectRows.map(function (item) {
            return {
                supplier_upper_goods_id: item.supplier_upper_goods_id,
                tax_rate: item.tax_rate,
                current: {
                    goods_price: item.current.goods_price || '',
                    es_time: item.current.es_time || '',
                    ee_time: item.current.ee_time || ''
                },
                next: {
                    goods_price: item.next.goods_price || '',
                    es_time: item.next.es_time || '',
                    ee_time: item.next.ee_time || '',
                    reason: item.next.reason || ''
                }
            };
        });
        this.basicArcheivesService.setSupplierupperGoodsPrice({
            supplier_upper_id: this.supplier_upper_id || '',
            data: JSON.stringify(paramsData)
        }).then(function (res) {
            if (res.data.success) {
                _this.$message.success('保存成功');
                _this.search();
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    PriceSetting.prototype.getCategory = function () {
        var _this = this;
        this.goodService.getCategory().then(function (res) {
            if (res.data.success) {
                _this.categoryData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    PriceSetting.prototype.getTreeCategoryData = function () {
        var _this = this;
        this.service.getCategoryTree().then(function (res) {
            _this.treeData = res.data.data;
        });
    };
    PriceSetting.prototype.pageChange = function (pager) {
        this.search(pager);
    };
    PriceSetting.prototype.handleSearch = function () {
        var pagination = this.$refs.pagination;
        pagination.clear();
        this.search(pagination.getPage());
    };
    PriceSetting.prototype.setSelectRows = function (rows) {
        this.selectRows = rows;
    };
    PriceSetting.prototype.saveItem = function (data) {
        var _this = this;
        this.basicArcheivesService.setSupplierupperGoodsPrice({
            supplier_upper_id: this.supplier_upper_id || '',
            data: JSON.stringify(data)
        }).then(function (res) {
            if (res.data.success) {
                _this.$message.success('保存成功');
                _this.search();
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    PriceSetting.prototype.importData = function () {
        this.dialogTableVisible = true;
        this.setUploadType("beford");
    };
    PriceSetting.prototype.befordUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (!(fileType && (fileType == "xlsx" || fileType == "xls"))) {
            this.$message.error("文件只能是xlsx或xls");
            return false;
        }
        ;
        if (!this.loadingInstance)
            this.loadingInstance = Loading.service({ fullscreen: true });
    };
    PriceSetting.prototype.uploadSuccess = function (response, file, fileList) {
        if (response.success) {
            this.responseSuccess = true;
            var data = response.data;
            this.importSuccessNum = data.success_num;
            this.importFailnum = data.error_num;
            var url = "/supplierclientapi/supplieruppergoodsprice/export_error?import_id=" + data.import_id;
            url = UrlHelper.addParam(url, 'token', this.user.token);
            this.failDownLoadUrl = url;
            this.$emit('search');
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || "网络异常，请重新导入";
            this.$message.error(response.msg);
        }
        this.uploadEnd(response);
    };
    PriceSetting.prototype.uploadError = function (err, file, fileList) {
        this.responseFail = true;
        this.errorMsg = err.msg || err.message || "网络异常，请重新导入";
        this.uploadEnd();
    };
    PriceSetting.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = "";
            this.setUploadType("beford");
        }
        else {
            this.setUploadType("after");
        }
        this.loadingInstance.close();
    };
    PriceSetting.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType("importing");
    };
    PriceSetting.prototype.setUploadType = function (type) {
        this.befordImport = type == 'beford';
        this.importting = type == 'importing';
        this.afterImport = type == 'after';
    };
    PriceSetting.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    PriceSetting = __decorate([
        Component({
            components: {
                'bill-header': BillHeader,
                'left-tree': LeftTree,
                'category-table': CategoryTable
            },
            computed: __assign({}, mapGetters({
                "user": "user"
            })),
        })
    ], PriceSetting);
    return PriceSetting;
}(Vue));
export default PriceSetting;
